import { render, staticRenderFns } from "./NavigationSidebar.component.vue?vue&type=template&id=7ed366e9&scoped=true"
import script from "./NavigationSidebar.component.vue?vue&type=script&lang=js"
export * from "./NavigationSidebar.component.vue?vue&type=script&lang=js"
import style0 from "./NavigationSidebar.component.vue?vue&type=style&index=0&id=7ed366e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed366e9",
  null
  
)

export default component.exports